export default __webpack_public_path__ + "images/6bb6f8d824ff7f2e6cabb023b0ebaa17.png";